import data from './data.json'

interface LocaleData {
  cases: string[]
  languages: { code: string, name: string }[]
  allLanguages: { code: string, name: string }[]
}

export default data as LocaleData
